const UUID_PATTERN =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;

/**
 * Returns a URL's path with IDs replaced by `:id`, so requests for different
 * records group together in Sentry. Query strings are dropped.
 */
export const normalizeApiPath = (url: string): string => {
  let path = url;
  try {
    path = new URL(url).pathname;
  } catch {
    // Keep the raw value if it isn't an absolute URL
    path = url.split("?")[0];
  }
  return path
    .replace(UUID_PATTERN, ":id")
    .replace(NUMERIC_SEGMENT_PATTERN, "/:id");
};
